export default "<lib-recuperar-senha-sucesso></lib-recuperar-senha-sucesso>\n";